import React from "react";
import { useNavigate } from "react-router-dom";

import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";

const ProjectCreate = () => {
  const { projectListApi } = apiPath;
  const { projectList } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "file",
      label: "Thumbnail Image",
      type: "file",
      name: "thumbnail",
      required: true,
    },
    {
      elementType: "file",
      label: "Banner Image",
      type: "file",
      name: "projectBannerImage",
      required: true,
    },
    {
      elementType: "file",
      label: "Project Brief Image",
      type: "file",
      name: "image",
      required: false,
    },
    {
      elementType: "input",
      label: "Project Title",
      type: "Text",
      name: "projectTitle",
      required: true,
    },
    {
      elementType: "input",
      label: "Project Link",
      type: "Text",
      name: "projectLink",
      required: false,
    },

    {
      elementType: "input",
      label: "Project Brief Title",
      type: "Text",
      name: "detailTitle",
      required: false,
    },
    {
      elementType: "textField",
      label: "Project Brief Detail",
      type: "Text",
      name: "detailParagraph",
      required: false,
    },
    {
      elementType: "input",
      label: "Client Name",
      type: "Text",
      name: "clientName",
      required: false,
    },
  ];

  const imagesData = [];
  [1]?.map((item, index) => {
    imagesData.push({
      label: `Slider Image ${index}`,
      type: "file",
      name: "",
      defaultValue: "",
      required: false,
    });
  });

  const nestedData = [
    {
      elementType: "file",
      label: "Slider Image",
      name: "images",
      multipleData: imagesData,
      multiple: true,
      fullCol: true,
      required: false,
    },
  ];

  const multiDimensionalData = [
    {
      elementType: "nested",
      label: "Role",
      name: "role",
      multiple: true,
      required: false,
      noDropdown: true,
    },
  ];
  const midData = [
    {
      elementType: "textField",
      label: "Process Subheading",
      type: "Text",
      name: "processDetails",
      required: false,
    },
  ];

  const moreData = [
    {
      elementType: "input",
      label: "Project Status",
      type: "text",
      name: "projectStatus",
      required: false,
    },
    {
      elementType: "input",
      label: "Date",
      type: "date",
      name: "date",
      required: false,
    },
    {
      elementType: "input",
      label: "Category",
      type: "Text",
      name: "category",
      required: true,
    },
    {
      elementType: "textField",
      label: "Challenges Paragraph",
      type: "Text",
      name: "challengesDetail",
      required: false,
    },
  ];

  const multiDimensionalMultipleDataProject = [
    {
      elementType: "nestedMultiple",
      label: "Process Detail",
      name: "dynamicDetail",
      multiple: true,
      required: false,
      noImage: true,
    },
    {
      elementType: "nestedMultiple",
      label: "Problem Solving Detail",
      name: "problemSolvingDetail",
      multiple: true,
      required: false,
      noImage: true,
    },
  ];

  const endData = [
    {
      elementType: "textField",
      label: "Conclusion",
      type: "Text",
      name: "conclusion",
      required: false,
      fullCol: true,
    },
  ];

  const useData = data.concat(
    multiDimensionalData,
    moreData,
    nestedData,
    midData,
    multiDimensionalMultipleDataProject,
    endData
  );

  const update = (data) => {
    const filteredRoleArray = data.role
      .map((item) => item.filter((item) => item))
      .map((item) => item[0]);
    data.role = filteredRoleArray;
    const newImgArray = data?.images?.map((item) => {
      const newObj = {};
      newObj.image = item;
      return newObj;
    });
    data.images = newImgArray;
    updateData(projectListApi, data, null, null, null, true);
    setTimeout(() => {
      navigate("/" + projectList);
    }, 1000);
  };

  return (
    <div>
      <GlobalForm
        data={useData}
        nestedData={nestedData}
        multiDimensionalData={multiDimensionalData}
        multiDimensionalMultipleDataProject={
          multiDimensionalMultipleDataProject
        }
        update={update}
      />
    </div>
  );
};

export default ProjectCreate;
